<template>
  <div>
    <div class="row create-challenge-button" v-if="isAdmin">
      <md-button type="button" class="md-success" @click="redirectToChallenges">{{$t('challengePage.createChallenge')}}</md-button>
    </div>
    <span class="md-headline">{{$t('challengePage.availabeChallenges')}}: </span>
    <div class="md-layout challengeList">
      <div
        v-for="challenge in available"
        v-bind:key="challenge._id"
        @click="redirectTo(challenge)"
        class="md-layout-item md-small-size-100 md-size-33"
      >
        <challenge-card card-header="true" class="card">
          <img slot="imageHeader" v-if="challenge.titleImage" :src="challenge.titleImage" />
          <div class="h4" slot="title" v-html="challenge.title"></div>
          <span slot="date">
            {{ formatFromToDate(challenge.start, challenge.end) }}
          </span>
          <p
            slot="description"
            v-html="challenge.feedDescription"
            class="card-description"
          ></p>
        </challenge-card>
      </div>
    </div>
    <span class="md-headline">{{$t('challengePage.activeChallenges')}}: </span>
    <div class="md-layout challengeList">
      <div
        v-for="challenge in joined"
        v-bind:key="challenge._id"
        @click="redirectTo(challenge)"
        class="md-layout-item md-small-size-100 md-size-33"
      >
        <challenge-card card-header="true" class="card">
          <img
            slot="imageHeader"
            :src="challenge.titleImage"
            v-if="challenge.titleImage"
          />
          <div class="h4" slot="title" v-html="challenge.title"></div>
          <span slot="date">
            {{ formatFromToDate(challenge.start, challenge.end) }}
          </span>
          <p
            slot="description"
            v-html="challenge.feedDescription"
            class="card-description"
          ></p>
        </challenge-card>
        <!--         <product-card
          :cardHeader="challenge.titleImage ? 'true' : 'false'"
          header-animation="true"
        >
          <img
            class="img challengeTitleImg"
            slot="imageHeader"
            :src="challenge.titleImage"
          />
          <h4 slot="title" class="title" v-html="challenge.title"></h4>
          <div
            slot="description"
            class="card-description"
            v-if="
              challenge.feedDescription ||
                (challenge.description && challenge.description.length < 220)
            "
            v-html="challenge.feedDescription || challenge.description"
          ></div>
          <div
            slot="description"
            class="card-description"
            v-else-if="challenge.description"
            v-html="challenge.description.substring(0, 220) + '...'"
          ></div>
          <template slot="footer">
            <div class="price">
              <h4>{{ formatDate(challenge.start) }}</h4>
            </div>
          </template>
        </product-card>
 -->
      </div>
    </div>

    <span class="md-headline">{{$t('challengePage.finishedChallenges')}}: </span>
    <div class="md-layout challengeList">
      <div
        v-for="challenge in done"
        v-bind:key="challenge._id"
        @click="redirectTo(challenge)"
        class="md-layout-item md-small-size-100 md-size-33"
      >
        <challenge-card card-header="true" class="card">
          <img
            slot="imageHeader"
            :src="challenge.titleImage"
            v-if="challenge.titleImage"
          />
          <div class="h4" slot="title" v-html="challenge.title"></div>
          <span slot="date">
            {{ formatFromToDate(challenge.start, challenge.end) }}
          </span>
          <p
            slot="description"
            v-html="challenge.feedDescription"
            class="card-description"
          ></p>
        </challenge-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ChallengeCard } from "@/components";
import datetime from "@/utils/datetime";

export default {
  components: {
    ChallengeCard
  },
  data() {
    return {
      available: {},
      joined: {},
      done: {}
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  mounted() {
    this.$store
      .dispatch("queryAPI", {url: "/rest/challenge?view=available&sort=start&sortOrder=desc"})
      .then(data => {this.available = data;});

    this.$store
      .dispatch("queryAPI", {url: "/rest/challenge?view=joined&sort=start&sortOrder=desc"})
      .then(data => {this.joined = data;});

    this.$store
      .dispatch("queryAPI", {url: "/rest/challenge?view=done&sort=start&sortOrder=desc"})
      .then(data => {this.done = data;});
  },
  methods: {
    ...datetime,
    redirectTo(challenge) {
      if(challenge.public) {
        this.$router.push("/Challenges/" + challenge._id);
      } else {
        this.$router.push("/Challenges/private/" + challenge._id);
      }

    },
    redirectToChallenges() {
      this.$router.push("/Challenges/private")
    }
  }
};
</script>

<style>
.challengeTitleImg {
  height: 400px;
}

.create-challenge-button {
  display: flex;
  justify-content: flex-end;
}
.challengeList {
  margin-top: 60px;
}
</style>
